import React from "react";
import { StageElement } from "../../types";

interface DefaultComponentRendererProps {
  element?: StageElement;
  children?: React.ReactNode;
}

export const DefaultComponentRenderer: React.FC<DefaultComponentRendererProps> = ({
  element,
  children,
}) => {
  if (element?.type) {
    return null;
  } else {
    return <div style={style}> .Need component: {children}</div>;
  }
};

const style: React.CSSProperties = {
  backgroundColor: "#b8860b", // dark yellow
  border: "2px solid #fffacd", // light yellow border
  borderRadius: "8px", // rounded borders
  height: "50px",
};
